
import { Spanish } from "../_Translate/Spanish";
import { English } from "../_Translate/English";

export const HAS__LOGIN_RESOURCE_API = false;

const TRANSLATE = { es: Spanish, en: English };

export const onLoginContent = (lang = "es") => (TRANSLATE[lang] ?? Spanish).LOGIN;

export const LOGIN_CONTENT = onLoginContent();
